import { basketActions } from "~/providers/store/basket";
import { usePosCategories } from "~/providers/store/basket/hooks/use-pos-categories";
import { useBasketContext } from "~/providers/store/basket/context";

import { CategoriesLayout } from "./categories-layout";
import { CategoryItem } from "./category-item";

export const HeaderCategories = () => {
  const { categories, status } = usePosCategories();
  const activeCategory = useBasketContext((state) => state.activeCategory);

  if (status !== "success") {
    return (
      <CategoriesLayout count={4}>
        {skeletonArray.map(({ id }) => (
          <CategoryItem className="animate-pulse" key={id} />
        ))}
      </CategoriesLayout>
    );
  }

  const categoryCount = categories.length;

  if (categoryCount < 2) return null;

  return (
    <CategoriesLayout count={categoryCount}>
      {categories.map((category) => (
        <CategoryItem
          key={category.id}
          onClick={() => {
            basketActions.setActiveCategoryId(category.id);
          }}
          isActive={activeCategory?.id === category.id}
        >
          {category.name}
        </CategoryItem>
      ))}
    </CategoriesLayout>
  );
};

const skeletonArray = Array.from(Array(4).keys()).map((_, index) => ({
  id: index
}));
